import { render, staticRenderFns } from "./remind.vue?vue&type=template&id=8053377c"
import script from "./remind.vue?vue&type=script&lang=js"
export * from "./remind.vue?vue&type=script&lang=js"
import style0 from "./remind.vue?vue&type=style&index=0&id=8053377c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports